import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import InputIcon from 'app/components/InputIcon/InputIcon';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import DialogActions from '@mui/material/DialogActions';
import { useLocation, useNavigate } from "react-router-dom";
import addRefferalSchema from './addRefferalSchema';
import InputMask from 'app/components/InputMask/InputMask';
import Swal from 'sweetalert2';
import { requestApi } from 'app/utils/RestApi';
import ButtonStyled from 'app/components/ButtonStyled/ButtonStyled';
import { setupParamsReferrer } from 'app/services/setupWebview';
import DropdownInput from 'app/components/DropdownInput/DropdownInput';
import { COMMON, DRAFT, REFERRER } from 'app/utils/constants/endPoint';
import { formatNpwpNumber } from 'app/utils/appHelpers';
import moment from 'moment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePicker from 'react-datepicker';
import { isMobile } from 'react-device-detect';
import { Field, Form, Formik } from 'formik';
import { Required } from 'app/utils/constants/validation';

const WebViewAddRefferal = () => {
	const navigate = useNavigate();

	const location = useLocation()

	const [fieldTouched, setFieldTouched] = React.useState({
		name: false,
		ktpNumber: false,
		gender: false,
		country: false,
		negaraLahir: false,
		nationality: false,
		phoneNumber: false,
		email: false,
		bankName: null,
		accountNumber: false,
		accountName: false,
		npwpStatus: false,
		npwpNumber: false,
		birthDate: false,
		agentCode: false
	});

	const fileInputRef = React.useRef(null);
	const fileInputRef2 = React.useRef(null);

	const [openDate, setOpenDate] = React.useState(false);

	const [ktpImage, setKtpImage] = React.useState('');
	const [npwpImage, setNpwpImage] = React.useState('');

	const [mstBank, setMstBank] = React.useState([])
	const [mstCountries, setMstCountries] = React.useState([])

	let referrer = null

	if (location?.state) {
		referrer = location?.state?.referrer
	}

	const [bankName, setBankName] = React.useState(null);
	const [selectedCountry, setSelectedCountry] = React.useState({
		nationality: {
			"code": "RI",
			"longdesc": "Indonesia",
			"shortdesc": "Indonesia"
		},
		negaraLahir: {
			"code": "RI",
			"longdesc": "Indonesia",
			"shortdesc": "Indonesia"
		},
		country: {
			"code": "RI",
			"longdesc": "Indonesia",
			"shortdesc": "Indonesia"
		}
	});
	const labeling = {
		id: 'value',
		name: 'label'
	}
	const labeling2 = {
		id: 'longdesc',
		name: 'longdesc'
	}

	const navigateBack = () => {
		navigate(-1);
	};

	const [formData, setFormData] = React.useState({
		name: '',
		ktpNumber: '',
		gender: '',
		country: 'Indonesia',
		negaraLahir: 'Indonesia',
		nationality: 'Indonesia',
		phoneNumber: '',
		email: '',
		bankName: null,
		accountNumber: '',
		accountName: '',
		npwpStatus: '',
		npwpNumber: '',
		birthDate: '',
		agentCode: ''
	})


	React.useEffect(() => {
		// if (!isMobile) {
		// 	Swal.fire({
		// 		icon: 'warning',
		// 		title: 'Forbidden!',
		// 		text: 'Halaman ini tidak dapat diakses melalui browser',
		// 		allowOutsideClick: false,
		// 		showConfirmButton: false
		// 	});
		// } else {
			fetchMsData();
			if (!referrer) {
				let parameter = localStorage.getItem('paramsReferrer')
				if (!parameter) parameter = location.search
				setupParamsReferrer(parameter, ({ agentCode }) => {
					setFormData({
						...formData,
						agentCode
					})
				}, false, navigateBack)
			}
		// }
	}, []);

	const doSubmit = async (values) => {
		if (!ktpImage) {
			Swal.fire({
				icon: 'warning',
				text: 'Silakan pilih foto ktp'
			});
			return false;
		} else if (values.npwpStatus == '01' && !npwpImage) {
			if (!npwpImage) {
				Swal.fire({
					icon: 'warning',
					text: 'Silakan pilih foto npwp'
				});
				return false;
			}
		}

		await sendData(values);
	};

	const preparePayload = (data) => {
		let request = {
			name: (data.name).trim(),
			ktpNumber: (String(data.ktpNumber)).trim(),
			country: (data.country).trim(),
			countryBirth: (data.negaraLahir).trim(),
			nationality: data.nationality.trim(),
			gender: (data.gender).trim(),
			phoneNumber: (data.phoneNumber).trim(),
			email: (data.email).trim(),
			bankCode: bankName.value,
			bankName: bankName.label,
			accountNumber: (String(data.accountNumber)).trim(),
			accountName: (data.accountName).trim(),
			npwpStatus: data.npwpStatus == '01',
			npwpNumber: data.npwpStatus != '01' ? '' : formatNpwpNumber(data.npwpNumber),
			ktpImage: ktpImage,
			npwpImage: data.npwpStatus != '01' ? '' : npwpImage,
			agentCode: formData?.agentCode?.trim(),
			birthDate: (data.birthDate).trim(),
		}

		if(request?.agentCode?.includes('%20')) {
			request.agentCode = request.agentCode.replaceAll("%20","")
		}

		if (referrer?.id) {
			request.id = referrer?.id
		}

		return request;
	}

	const sendData = async (values) => {
		const payload = preparePayload(values);
		
		Swal.showLoading()
		await requestApi(REFERRER.CREATE, {
			data: payload
		}).then(({ data }) => {
			Swal.close();
			if (data?.status === 'success') {
				localStorage.setItem('tab', 0);
				navigateBack();
				localStorage.removeItem("refferer_memory")
				Swal.fire({
					icon: 'success',
					text: 'Data berhasil disimpan'
				});
			}
		}).catch(err => {
			Swal.close();
			if (err?.data) {
				var arrayError = [];
				for (let [key, value] of Object.entries(err.data)) {
					arrayError.push(value)
				}
				var errorJoin = arrayError.join('<br>');

				Swal.fire({
					icon: 'error',
					text: errorJoin
				});
			} else if (err?.message) {
				Swal.fire({
					icon: 'error',
					text: err.message
				});
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Bad request'
				});
			}
		})
	}

	const sendDataDraft = async (values) => {
		const payload = preparePayload(values);

		Swal.showLoading()
		await requestApi(DRAFT.ADD, {
			data: payload
		}).then(({ data }) => {
			Swal.close();

			if (data?.status === 'success') {
				localStorage.setItem('tab', 1);
				navigateBack();
				localStorage.removeItem("refferer_memory")
				Swal.fire({
					icon: 'success',
					text: 'Data berhasil disimpan'
				});
			}
		}).catch(err => {
			console.log('DRAFT.CREATE error ', err);
			Swal.close();
			if (err?.data) {
				var arrayError = [];
				for (let [key, value] of Object.entries(err.data)) {
					arrayError.push(value)
				}
				var errorJoin = arrayError.join('<br>');

				Swal.fire({
					icon: 'error',
					text: errorJoin
				});
			} else if (err?.message) {
				Swal.fire({
					icon: 'error',
					text: err.message
				});
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Bad request'
				});
			}
		})
	}

	const handleImageUpload = (event, setImage) => {
		const file = event.target.files[0];
		if (file && file.size <= 1000000) {
			const reader = new FileReader();
			reader.onloadend = () => {
				setImage(reader.result);
			};
			reader.readAsDataURL(file);
		} else {
			if (file) {
				Swal.fire({
					icon: 'error',
					text: 'File teralu besar. Maksimal Upload File 2MB.'
				});
			}
		}
	};

	const handleImageClick = (event) => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	const handleImageClick2 = (event) => {
		if (fileInputRef2.current) {
			fileInputRef2.current.click();
		}
	};

	function formatString(str) {
		if (str.length !== 15) {
			return "";
		}

		const part1 = str.slice(0, 2);
		const part2 = str.slice(2, 5);
		const part3 = str.slice(5, 8);
		const part4 = str.slice(8, 9);
		const part5 = str.slice(9, 12);
		const part6 = str.slice(12, 15);

		return `${part1}.${part2}.${part3}.${part4}-${part5}.${part6}`;
	}

	const fetchMsData = async () => {
		let mstBankTmp = []
		let mstCountryTmp = []
		await requestApi(COMMON.MASTER_BANK, {
			params: {
				name: ""
			}
		}).then(({ data }) => {
			if (data.data) {
				if (data.data.length) {
					setMstBank(data.data)
					mstBankTmp = data.data
				}
			}
		}).catch(err => console.log(err))

		await requestApi(COMMON.MASTER_COUNTRIES).then(({ data }) => {
			if (data.data) {
				if (data.data.length) {
					const formattedData = data.data.map(item => ({
						...item,
						code: item.DESCITEM || item.CODE || item.code || '',
						longdesc: item.LONGDESC || item.longdesc || '',
						shortdesc: item.SHORTDESC || item.shortdesc || '',
						desctabl: item.DESCTABL || item.desctabl || ''
					}));
					setMstCountries(formattedData)
					mstCountryTmp = formattedData
				}
			}
		}).catch(err => console.log(err))

		if (referrer) {
			let selectedCountryTmp = { ...selectedCountry }

			if (mstCountryTmp.length > 0) {
				for (let [_, field] of ['country', 'countryBirth', 'nationality'].entries()) {
					if (referrer[field]) {
						selectedCountryTmp[field == 'countryBirth' ? 'negaraLahir' : field] = mstCountryTmp.find(f => f.longdesc == referrer[field])
					}
				}
			}

			if (mstBankTmp.length > 0) {
				if (referrer.bankCode) {
					setBankName(mstBankTmp.find(f => f.value == referrer.bankCode))
				}
			}
			var npwpNumberData = (referrer.npwpNumber) ? formatString(referrer.npwpNumber) : ""
			setFormData({
				...referrer,
				npwpNumber: npwpNumberData,
				birthDate: !referrer.birthDate ? '' : referrer.birthDate.split('T')[0],
				negaraLahir: referrer.countryBirth,
				npwpStatus: referrer.npwpStatus ? '01' : '00'
			});

			if (referrer.npwpImage) {
				setNpwpImage(referrer.npwpImage)
			}
			if (referrer.ktpImage) {
				setKtpImage(referrer.ktpImage)
			}

		}

	}


	const handleDropdownChange = (data) => {
		setBankName(data)
	};
	const handleDropdownCountryChange = (data, field) => {
		setSelectedCountry((prevState) => ({
			...prevState,
			[field]: data
		}))
	};

	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Add Referrer"}
				backOnClick={navigateBack}
			/>
			<Formik
				initialValues={formData}
				enableReinitialize={true}
				validationSchema={addRefferalSchema}
				onSubmit={(values) => {
					doSubmit(values)
				}}
			>
				{({ errors, values, handleSubmit, setValues }) => {

					function formikSetValue(field, value) {
						setValues({
							...values,
							[field]: value
						})
					}
					return (
						formData &&
						<Form style={{ width: '100%' }}>
							{/* 🔥 CONTENT */}
							<ContentWrapper isMobile>


								{/* 🔥 typography */}
								<Typography fontSize={16} fontWeight={600}>Silakan Lengkapi Data Diri Anda</Typography>

								{/* 🔥 input with icon left/right */}

								<Div sx={{ mt: 2 }}>
									<Div sx={{ mb: 2 }}>
										<Field name="name">
											{({
												field,
												value,
												form: { handleChange },
												meta,
											}) => (
												<>
													<InputIcon
														required
														name="name"
														value={meta.value}
														onChange={handleChange}
														inputLabel={"Nama Lengkap (sesuai KTP)"}
														placeholder={"Nama Lengkap"}
														onBlur={() => {
															if (!fieldTouched.name) {
																setFieldTouched((prevState) => ({ ...prevState, ['name']: true }))
															}
														}}
													/>
													{(fieldTouched.name && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</>
											)}
										</Field>
									</Div>
									<Field name="ktpNumber">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<InputIcon
													{...field}
													name="ktpNumber"
													value={meta.value}
													type="number"
													required
													onChange={handleChange}
													inputLabel={"Nomor KTP"}
													placeholder={"Nomor KTP"}
													onBlur={() => {
														if (!fieldTouched.ktpNumber) {
															setFieldTouched((prevState) => ({ ...prevState, ['ktpNumber']: true }))
														}
													}}

												/>
												{(fieldTouched.ktpNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
											</>
										)}
									</Field>
									<br />

									<Field name="birthDate">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<DatePicker
													open={openDate}
													value={meta.value}
													selected={!meta.value ? new Date(moment().subtract(17, 'years').format('YYYY-MM-DD')) : new Date(meta.value)}
													onChange={(date) => {
														setValues({ ...values, ['birthDate']: moment(date).format('YYYY-MM-DD') })
													}}
													placeholderText='Tanggal Lahir'
													onClickOutside={() => {
														setOpenDate(false)
														if (!fieldTouched.birthDate) {
															setFieldTouched((prevState) => ({ ...prevState, ['birthDate']: true }))
														}
													}}
													maxDate={new Date(moment().subtract(17, 'years').format('YYYY-MM-DD'))}
													onSelect={(e) => {
														setOpenDate(false)
														if (!fieldTouched.birthDate) {
															setFieldTouched((prevState) => ({ ...prevState, ['birthDate']: true }))
														}
													}}
													dateFormat="dd/MM/yyyy"
													peekNextMonth
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
													styles={{
														container: (provided) => ({
															...provided,
															zIndex: 9999, // Set a high z-index value
														}),
													}}
													customInput={
														<FormControl>
															<InputIcon
																required
																onFocus={() => {
																	if (!openDate) {
																		setOpenDate(true)
																	}
																}}
																name="birthDate"
																value={meta.value}
																onChange={handleChange}
																inputLabel={"Tanggal Lahir"}
																placeholder="YYYY-MM-DD"
															/>
															{(fieldTouched.birthDate && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
														</FormControl>}
													leftIcon={<CalendarMonthIcon sx={{ fontSize: 24 }} />}
												/>
										)}
									</Field>
									<br />
									<br />

									<Field name="gender">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<FormControl sx={{ mb: 2 }}>
													<FormLabel id="demo-row-radio-buttons-group-label">
														<Typography fontSize={12} color={"black"} fontWeight={500}>Jenis Kelamin {Required}</Typography>
													</FormLabel>
													<RadioGroup
														row
														aria-labelledby="demo-row-radio-buttons-group-label"
														name="gender"
														value={meta.value}
														onChange={handleChange}
														onBlur={() => {
															if (!fieldTouched.gender) {
																setFieldTouched((prevState) => ({ ...prevState, ['gender']: true }))
															}
														}}
													>
														<FormControlLabel value="M" control={<Radio />} label="Pria" />
														<FormControlLabel value="F" control={<Radio />} label="Wanita" />
													</RadioGroup>
													{(fieldTouched.gender && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</FormControl>)}
									</Field>

									<Field name="country">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<Div sx={{ mb: 2 }}>
													<Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>Negara Tinggal {Required}</Typography>
													<DropdownInput
														required
														data={mstCountries}
														defaultValue={"Silakan pilih Negara Tinggal"}
														size={'small'}
														inputLabel={"Negara Tinggal"}
														placeholder={"Negara Tinggal"}
														name="country"
														value={selectedCountry.country}
														noTitle={true}
														onBlur={() => {
															if (!fieldTouched.country) {
																setFieldTouched((prevState) => ({ ...prevState, ['country']: true }))
															}
														}}
														onChange={(_, data) => {
															handleDropdownCountryChange(data, 'country')
															// handleChange(e)
															formikSetValue('country', data ? data[[labeling2.id]] : '')
														}}
														labeling={labeling2}
													/>
													{(fieldTouched.country && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>)}
									</Field>

									<Field name="negaraLahir">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<Div sx={{ mb: 2 }}>
													<Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>Negara Lahir {Required}</Typography>
													<DropdownInput
														required
														data={mstCountries}
														defaultValue={"Silakan pilih Negara Lahir"}
														size={'small'}
														inputLabel={"Negara Lahir"}
														placeholder={"Negara Lahir"}
														name="negaraLahir"
														noTitle={true}
														value={selectedCountry.negaraLahir}
														onBlur={() => {
															if (!fieldTouched.negaraLahir) {
																setFieldTouched((prevState) => ({ ...prevState, ['negaraLahir']: true }))
															}
														}}
														onChange={(_, data) => {
															handleDropdownCountryChange(data, 'negaraLahir')
															// handleChange(e)
															formikSetValue('negaraLahir', data ? data[[labeling2.id]] : '')
														}}
														labeling={labeling2}
													/>
													{(fieldTouched.negaraLahir && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>)}
									</Field>

									<Div sx={{ mb: 2 }}>
										<InputIcon
											disabled
											name="nationality"
											inputLabel={"Kewarganegaraan"}
											placeholder={"Kewarganegaraan"}
											value={"Indonesia"}
										/>
									</Div>

									<Field name="phoneNumber">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<InputIcon
														required
														type={'tel'}
														name="phoneNumber"
														onChange={handleChange}
														inputLabel={"Nomor Telepon Seluler"}
														placeholder={"628xxxxxxxxx"}
														value={meta.value}
														onBlur={() => {
															if (!fieldTouched.phoneNumber) {
																setFieldTouched((prevState) => ({ ...prevState, ['phoneNumber']: true }))
															}
														}}

													/>
													{(fieldTouched.phoneNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>

									<Field name="email">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<InputIcon
														required
														value={meta.value}
														onBlur={() => {
															if (!fieldTouched.email) {
																setFieldTouched((prevState) => ({ ...prevState, ['email']: true }))
															}
														}}
														name="email"
														onChange={handleChange}
														inputLabel={"Alamat Email"}
														placeholder={"Alamat Email"}

													/>
													{(fieldTouched.email && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>

									<Field name="bankName">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<Typography variant={"body1"} fontWeight={500} mb={1} fontSize={12}>Nama Bank {Required}</Typography>
													<DropdownInput
														required

														data={mstBank}
														value={bankName}
														onBlur={() => {
															if (!fieldTouched.bankName) {
																setFieldTouched((prevState) => ({ ...prevState, ['bankName']: true }))
															}
														}}
														defaultValue={"Silakan pilih Nama Bank"}
														size={'small'}
														inputLabel={"Nama Bank"}
														placeholder={"Nama Bank"}
														name="bankName"
														noTitle={true}
														onChange={(_, data) => {
															handleDropdownChange(data)
															// handleChange(data[[labeling.id]])
															formikSetValue('bankName', data[[labeling.id]])

														}}
														labeling={labeling}
													/>
													{(fieldTouched.bankName && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>

									<Field name="accountNumber">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<InputIcon
														required
														value={meta.value}
														onBlur={() => {
															if (!fieldTouched.accountNumber) {
																setFieldTouched((prevState) => ({ ...prevState, ['accountNumber']: true }))
															}
														}}
														name="accountNumber"
														type='tel'
														onChange={handleChange}
														inputLabel={"Nomor Rekening"}
														placeholder={"Nomor Rekening"}

													/>
													{(fieldTouched.accountNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>

									<Field name="accountName">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div sx={{ mb: 2 }}>
													<InputIcon
														required
														value={meta.value}
														onBlur={() => {
															if (!fieldTouched.accountName) {
																setFieldTouched((prevState) => ({ ...prevState, ['accountName']: true }))
															}
														}}
														name="accountName"
														onChange={handleChange}
														inputLabel={"Nama Pemilik Rekening (Sesuai Buku Tabungan)"}
														placeholder={"Nama Pemilik Rekening "}

													/>
													{(fieldTouched.accountName && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
												</Div>
											</>)}
									</Field>

									<Field name="npwpStatus">
										{({
											field,
											value,
											form: { handleChange },
											meta,
										}) => (
											<>
												<Div>
													<FormControl>
														<FormLabel id="demo-row-radio-buttons-group-label">
															<Typography fontSize={12} color={"black"} fontWeight={500}>NPWP {Required}</Typography>
														</FormLabel>
														<RadioGroup
															value={meta.value}
															onBlur={() => {
																if (meta.value === '00') {
																	setNpwpImage('')
																	setValues({
																		...values,
																		['npwpNumber']: ''
																	})
																}
																if (!fieldTouched.npwpStatus) {
																	setFieldTouched((prevState) => ({ ...prevState, ['npwpStatus']: true }))
																}
															}}
															row
															aria-labelledby="demo-row-radio-buttons-group-label"
															name="npwpStatus"
															onChange={handleChange}
														>
															<FormControlLabel value="01" control={<Radio />} label="Ya" />
															<FormControlLabel value="00" control={<Radio />} label="Tidak" />
														</RadioGroup>
														{(fieldTouched.npwpStatus && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
													</FormControl>
												</Div>
											</>)}
									</Field>

									{
										values.npwpStatus === '01' &&
										<Field name="npwpNumber">
											{({
												field,
												value,
												form: { handleChange },
												meta,
											}) => (
												<>
													<Div sx={{ mb: 2 }}>
														<InputMask
															required={values.npwpStatus === '01'}
															value={meta.value}
															onBlur={() => {
																if (!fieldTouched.npwpNumber) {
																	setFieldTouched((prevState) => ({ ...prevState, ['npwpNumber']: true }))
																}
															}}
															mask="99.999.999.9-999.999"
															name="npwpNumber"
															onChange={handleChange}
															inputLabel={"Nomor NPWP"}
															placeholder={"Nomor NPWP"}
														/>
														{(fieldTouched.npwpNumber && meta.error) && <span style={{ color: 'red' }}>{meta.error}</span>}
													</Div>
												</>)}
										</Field>
									}
									<Typography sx={{ mt: 2 }} fontSize={12} fontWeight={600} textAlign={"center"}>Silakan Upload Dokumen-Dokumen Di bawah ini</Typography>

									<Div className='dis-flex-center' >
										<input
											ref={fileInputRef}
											type="file"
											style={{ display: "none" }}
											accept="image/*"
											onChange={(e) => handleImageUpload(e, setKtpImage)}  // Assuming first image upload is for KTP
										/>
										{
											values.npwpStatus === '01' &&
											<input
												ref={fileInputRef2}
												type="file"
												style={{ display: "none" }}
												accept="image/*"
												onChange={(e) => handleImageUpload(e, setNpwpImage)}  // Assuming first image upload is for KTP
											/>
										}
										<img
											src={ktpImage || `${process.env.REACT_APP_IMAGES_PATH}/KTP.svg`}
											onClick={handleImageClick}
											width={100}
											height={100}
											style={{ cursor: "pointer", objectFit: "contain" }}
										/>
										{
											values.npwpStatus === '01' &&
											<img
												src={npwpImage || `${process.env.REACT_APP_IMAGES_PATH}/NPWP.svg`}
												onClick={handleImageClick2}
												width={100}
												height={100}
												style={{ cursor: "pointer", objectFit: "contain", marginLeft: 10 }}
											/>
										}
									</Div>

								</Div>

							</ContentWrapper>

							{/* 🔥 FOOTER */}
							<MobileFooter>
								<DialogActions className='custom-btn'>
									<ButtonStyled
										disabled={(values.npwpStatus === '01' ? npwpImage == '' : false) || !ktpImage || (Object.values(errors).length > 0)}
										btnText={"Simpan"}
										onClick={() => sendDataDraft(values)}
										preset={"secondary"}
									/>
									<ButtonStyled
										disabled={(values.npwpStatus === '01' ? npwpImage == '' : false) || !ktpImage || (Object.values(errors).length > 0)}
										btnText={"Kirim"}
										preset={"primary"}
										onClick={handleSubmit}
									/>

								</DialogActions>

							</MobileFooter>
						</Form>
					)
				}}

			</Formik>
		</Div>

	);
};

export default WebViewAddRefferal;